module.exports = {"pageTitleText":"Resource Usage","resourceUsageLineChart":"Resource Usage"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/subscription.json
// module id = cq0S
// module chunks = 3